export default __webpack_public_path__ + "static/media/HyperTubeStart.64.4b84ca48.png";